<template>
  <div class="google-auth-cta mb-3">
    <button
      type="button"
      class="btn btn-outline-secondary btn-block google-auth-button mb-4 d-flex align-items-center justify-content-center"
      :class="{ 'mt-4': mode === 'signup' }"
      :disabled="disabled || loading"
      @click="redirectToGoogle"
    >
      <svg viewBox="0 0 24 24" width="24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"></path><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"></path><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"></path><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"></path></svg>
      <span class="ml-2">{{ computedCtaLabel }}</span>
    </button>

    <div class="google-auth-divider">
      <span>{{ $root.i18n.t('google_auth_divider_login') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleAuthCta',
  props: {
    mode: {
      type: String,
      default: 'login'
    },
    redirectPath: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ctaLabel: {
      type: String,
      default: null
    },
    dividerLabel: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    computedCtaLabel () {
      if (this.ctaLabel) return this.ctaLabel
      return this.mode === 'signup'
        ? this.$root.i18n.t('google_auth_cta_signup')
        : this.$root.i18n.t('google_auth_cta_login')
    }
  },
  methods: {
    redirectToGoogle () {
      this.loading = true
      this.$emit('start')
      try {
        this.$api.googleAuthRedirect(this.mode, this.redirectPath)
      } catch (error) {
        this.loading = false
        this.$emit('error', error)
      }
    }
  }
}
</script>

<style scoped>
.google-auth-button {
  border-color: #d7d7d7;
  color: #111;
  font-weight: 600;
  min-height: 44px;
}

.google-auth-button:hover {
  background-color: #fafafa;
}

.google-auth-divider {
  align-items: center;
  color: #6f6f6f;
  display: flex;
  font-size: 0.75rem;
  margin-top: 0.75rem;
  text-transform: uppercase;
}

.google-auth-divider::before,
.google-auth-divider::after {
  border-top: 1px solid #e6e6e6;
  content: '';
  flex: 1;
}

.google-auth-divider span {
  margin: 0 0.5rem;
}
</style>
